import { ImageIcon } from "lucide-react";

export const listAiModule = [
  {
    id: 'typhoon-ocr',
    title: 'Typhoon OCR',
    description: 'Extract text from images',
    tags: ['text extraction', 'image'],
    price: '$0.03 per request (~1฿)',
    icon: ImageIcon,
  },
];

// export const listAiModuleFullDetail = []
